import { PageWrapper } from '@/common/styles/Wrappers';
import React, { useEffect, useState } from 'react';
import { CenteredTable, ContentWrapper } from './Languages.styled';
import ActionButton from '@/common/components/buttons/ActionButton';
import LanguageForm from './components/languageForm/LanguageForm';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { getLanguages } from '@/API/repositories/language';
import Loading from '@/common/components/Loading';
import LanguageTable from './components/languageTable/LanguageTable';

const Languages = () => {
	const [isLanguageFormOpen, setIsLanguageFormOpen] = useState();
	const [languages, setLanguages] = useState();
	const [selectedLanguage, setSelectedLanguage] = useState();

	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const loadData = async () => {
		const response = await makeRequest(getLanguages);

		if (response.data) {
			setLanguages(() => response.data);
		}
	};

	useEffect(() => {
		if (!isLanguageFormOpen) {
			setSelectedLanguage(() => null);
		}
	}, [isLanguageFormOpen]);

	useEffect(() => {
		loadData();
	}, []);

	return (
		<PageWrapper>
			{hasUnfilledRequest(getLanguages) && <Loading />}
			<ContentWrapper>
				<ActionButton
					onClick={() => setIsLanguageFormOpen(() => true)}
					style={{ height: 'fit-content' }}
					defaultText='Add language'
				/>
				<CenteredTable>
					{languages && (
						<LanguageTable
							setSelectedLanguage={setSelectedLanguage}
							setIsLanguageFormOpen={setIsLanguageFormOpen}
							languages={languages}
						/>
					)}
				</CenteredTable>
			</ContentWrapper>
			{isLanguageFormOpen && (
				<LanguageForm
					selectedLanguage={selectedLanguage}
					loadData={loadData}
					setShow={setIsLanguageFormOpen}
				/>
			)}
		</PageWrapper>
	);
};

export default Languages;
